export default __webpack_public_path__ + "static/media/shiba.f38d6fad.png";